/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-quyu" /> 街道管理 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div>
            <Button type="primary" @click="addcompany()">
              <Icon type="md-add" style="position: relative; top: -0.125rem" />&nbsp;新增街道
            </Button>
          </div>

          <div>
            <i-input
              prefix="ios-search"
              class="tabdiv"
              size="large"
              placeholder="搜索街道名称"
              style="width: 300px"
              v-model="streeName"
              @on-change="getCompanynameInfo(1)"
            />
          </div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :loading="tbLoading" :columns="columns2" :data="companylist" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200, 500]"
          :page-size="row"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>

      <Modal v-model="modal1" title="删除提示" ok-text="确定删除" @on-ok="ok" @on-cancel="cancel">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要删除这个街道吗？你的删除可能会影响接受端程序出错的问题！ </template>
        </Alert>
      </Modal>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      streeName: '', // 街道名
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      value: '',
      tbLoading: false, // 表格加载动画
      columns2: [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          minWidth: 90,
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '用户名',
          align: 'center',
          minWidth: 120,
          render: (h, column, params) => {
            return h('Tag', { props: { color: 'geekblue' } }, column.row.account);
          },
        },
        {
          title: '街道名',
          key: 'street_name',
          align: 'center',
          minWidth: 120,
        },
        {
          title: '地区',
          key: 'name',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 120,
          align: 'center',
          render: (h, column, params) => {
            return h('div', [
              h(
                'Icon',
                {
                  props: {
                    type: 'ios-trash',
                    title: '删除',
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#ed4014',
                  },
                  on: {
                    click: () => {
                      this.deldata(column.row.street_id);
                    },
                  },
                },
                '删除',
              ),
            ]);
          },
        },
      ],

      companylist: [], // 公司列表
      page: 1, // 页数
      row: 20, // 条数
      total: 0, // 总条数
    };
  },

  mounted() {
    this.getCompanynameInfo(1);
  },
  methods: {
    /**
     * 搜索街道
     */
    getCompanynameInfo(page) {
      this.select = 2;
      const api = this.ApiUrl + 'street/findByStreetNameLike';
      const data = {
        page: page,
        row: this.row,
        street_name: this.streeName,
      };
      this.tbLoading = true; // 开启加载动画
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            const list = res.data.extend.pageInfo.records;
            this.total = res.data.extend.pageInfo.total;
            this.page = page;
            this.companylist = list;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },
    ok() {
      const api = this.ApiUrl + 'street/delById';
      const data = {
        street_id: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            if (this.page > 0 && this.companylist.length == 1) {
              this.page -= 1;
            }
            this.getCompanynameInfo(this.page);
          }
          this.$Message.success('成功删除');
        },
        res => {},
      );
    },
    cancel() {
      this.$Message.info('取消删除');
    },

    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },
    // 表格事件处理
    show2(index) {
      sessionStorage.setItem('admid', index);
      this.$router.push({
        name: 'upStreet',
        params: {
          comid: index,
        },
      });
    },

    // 添加公司
    addcompany() {
      this.$router.push({
        name: 'addStreet',
      });
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getCompanynameInfo(1);
    },
    // 切换下一页
    onNextPage(e) {
      this.getCompanynameInfo(e);
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 点击确定事件1
     */
    clickOK1() {
      this.$Message.info('点击确认');
    },
    /**
     * 点击取消事件
     */
    clickCancel1() {
      this.$Message.info('点击取消');
    },
    /**
     * 删除事件
     */
    clickDel() {
      this.modal_loading = true; // 开启加载动画

      setTimeout(() => {
        this.modal_loading = false;
        this.modal2 = false;
        this.$Message.success('窗口隐藏');
      }, 2000);
    },
    /**
     * 加载html内容到弹窗
     */
    clickHTML() {
      this.modal3 = true;
      this.chtml =
        '<p>这个 <code>span</code> 的内容将会被替换成为属性值 <code>rawHtml</code>，直接作为 HTML——会忽略解析属性值中的数据绑定。注意，你不能使用 <code>v-html</code> 来复合局部模板，因为 Vue 不是基于字符串的模板引擎。反之，对于用户界面 (UI)，组件更适合作为可重用和可组合的基本单位。</p><p class="tip">你的站点上动态渲染的任意 HTML 可能会非常危险，因为它很容易导致 <a href="https://en.wikipedia.org/wiki/Cross-site_scripting" target="_blank" rel="noopener">XSS 攻击</a>。请只对可信内容使用 HTML 插值，<strong>绝不要</strong>对用户提供的内容使用插值。</p><p>在布尔特性的情况下，它们的存在即暗示为 <code>true</code>，<code>v-bind</code> 工作起来略有不同，在这个例子中：</p><pre><code class="hljs html"><span class="hljs-tag">&lt;<span class="hljs-name">button</span> <span class="hljs-attr">v-bind:disabled</span>=<span class="hljs-string">"isButtonDisabled"</span>&gt;</span>Button<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span></code></pre>';
    },
    /**
     * iview封装了一些实例方法，用来创建一次性的轻量级对话框。
     */
    dongtai() {
      const title = '标题';
      const content = '<p>内容。。。</p><p>Xujie。。。</p>';

      this.$Modal.success({
        title: title,
        content: content,
      });
    },
    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'newcompany',
        params: {
          admid: 123,
        },
      });
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-left: 1.25rem;
}
</style>
